export const APIKey = process.env.REACT_APP_OMDBKEY;
